import { ID } from 'api'
import { ProductMock } from '../products/data'

export interface AdvertiserMock {
  id: ID
  cmsId: ID
  name: string
  products: ProductMock[]
}

export const advertisers: AdvertiserMock[] = [
  {
    id: '1',
    cmsId: '123',
    name: 'Supersonic Studios',
    products: [
      {
        cmsId: '123521',
        id: '1',
        name: 'Lords Mobile: Tower Defense',
        advertiserCmsId: '123',
      },
      {
        cmsId: '123520',
        id: '2',
        name: 'Web product',
        advertiserCmsId: '123',
      },
    ],
  },
  {
    id: '2',
    cmsId: '124',
    name: 'Voodoo',
    products: [
      {
        cmsId: '123490',
        id: '3',
        name: 'Tinder - Dating, Make Friends and Meet New People',
        advertiserCmsId: '124',
      },
      {
        cmsId: '314037',
        id: '4',
        name: 'FINAL FANTASY VII',
        advertiserCmsId: '124',
      },
    ],
  },
  {
    id: '3',
    cmsId: '125',
    name: 'Lion Studios',
    products: [
      {
        cmsId: '234112',
        id: '5',
        name: 'MORTAL KOMBAT: The Ultimate Fighting Game!',
        advertiserCmsId: '125',
      },
      {
        cmsId: '123451',
        id: '6',
        name: 'Facebook',
        advertiserCmsId: '125',
      },
    ],
  },
  {
    id: '4',
    cmsId: '126',
    name: 'Kwalee',
    products: [
      {
        cmsId: '321333',
        id: '7',
        name: 'Lords: Tower Defense',
        advertiserCmsId: '126',
      },
      {
        cmsId: '546675',
        id: '8',
        name: 'Web product design',
        advertiserCmsId: '126',
      },
    ],
  },
  {
    id: '5',
    cmsId: '127',
    name: 'Gram Games',
    products: [
      {
        cmsId: '445667',
        id: '9',
        name: 'Make Friends and Meet New People',
        advertiserCmsId: '127',
      },
      {
        cmsId: '467774',
        id: '10',
        name: 'FINAL FANTASY VI',
        advertiserCmsId: '127',
      },
    ],
  },
  {
    id: '6',
    cmsId: '128',
    name: 'SayGames',
    products: [
      {
        cmsId: '675677',
        id: '11',
        name: 'MORTAL KOMBAT: Fatality!',
        advertiserCmsId: '128',
      },
      {
        cmsId: '884555',
        id: '12',
        name: 'Amazon',
        advertiserCmsId: '128',
      },
    ],
  },
  {
    id: '7',
    cmsId: '129',
    name: 'Playgendary',
    products: [
      {
        cmsId: '989890',
        id: '13',
        name: 'SkyWatcher: Star Guide',
        advertiserCmsId: '129',
      },
      {
        cmsId: '456789',
        id: '14',
        name: 'Epic Adventure Games',
        advertiserCmsId: '129',
      },
    ],
  },
  {
    id: '8',
    cmsId: '130',
    name: 'Ketchapp',
    products: [
      {
        cmsId: '564123',
        id: '15',
        name: 'Quantum Analytics',
        advertiserCmsId: '130',
      },
      {
        cmsId: '987654',
        id: '16',
        name: 'Crysis Warhead',
        advertiserCmsId: '130',
      },
    ],
  },
  {
    id: '9',
    cmsId: '131',
    name: 'Homa Games',
    products: [
      {
        cmsId: '234567',
        id: '17',
        name: 'Circuit Design Pro',
        advertiserCmsId: '131',
      },
      {
        cmsId: '654321',
        id: '18',
        name: 'HealthTrack: Fitness Planner',
        advertiserCmsId: '131',
      },
    ],
  },
  {
    id: '10',
    cmsId: '132',
    name: 'Crazy Labs',
    products: [
      {
        cmsId: '123456',
        id: '19',
        name: 'Elite Soccer League',
        advertiserCmsId: '132',
      },
      {
        cmsId: '456012',
        id: '20',
        name: 'Space Conquerors: Galactic War',
        advertiserCmsId: '132',
      },
    ],
  },
  {
    id: '11',
    cmsId: '133',
    name: 'Lucky Kat Studios',
    products: [
      {
        cmsId: '123116',
        id: '21',
        name: 'Elite Soccer Kick',
        advertiserCmsId: '133',
      },
      {
        cmsId: '452122',
        id: '22',
        name: 'Space Conquerors',
        advertiserCmsId: '133',
      },
    ],
  },
  {
    id: '12',
    cmsId: '134',
    name: 'Hyper Hippo',
    products: [
      {
        cmsId: '123426',
        id: '23',
        name: 'Elite Kick',
        advertiserCmsId: '134',
      },
      {
        cmsId: '124455',
        id: '24',
        name: 'Space',
        advertiserCmsId: '134',
      },
    ],
  },
]
